import React from 'react';
import axios from 'axios';
import { Switch, Route, Link, Redirect, withRouter } from 'react-router-dom';
import { Breadcrumb, Layout, notification } from 'antd';
const { Content, Sider } = Layout;

import apiPath from 'apiPath';
import moment from 'components/momentWithZone';
import stickyError from 'components/stickyError';
import Sidebar from 'components/Sidebar';
import { isEnabled, redirectIfHidden, menuItems } from './menuItems';
import withSpin from 'components/withSpin';
import calculateBalance from 'components/Portal/FieldPrograms/calculateBalance';

import Personal from 'components/Portal/Personal';
import FieldPrograms from 'components/Portal/FieldPrograms';
import Embarkation from 'components/Portal/Embarkation';
import Academic from 'components/Portal/Academic';
import Health from 'components/Portal/Health';
import Travel from 'components/Portal/Travel';
import Agreements from 'components/Portal/Agreements';
import Cabin from 'components/Portal/Cabin';
import Financial from 'components/Portal/Financial';
import PaymentError from 'components/Portal/PaymentError';
import PaymentFailed from 'components/Portal/PaymentFailed';
import Admissions from 'components/Portal/Admissions';
import Safety from 'components/Portal/Safety';
import App from 'localcomponents/App';

class RedirectAndClear extends React.Component {
	componentDidMount() {
		localStorage.removeItem('redirectAfterLogin');
	}
	render() {
		return <Redirect to={this.props.to} />;
	}
}

class Portal extends React.Component {
	state = {
		tick: false,

		configRules: [],
		section: null,
		subsection: null,

		folio: {},
		folioLoaded: false,
		folioError: false,

		booking: {},
		bookingLoaded: false,
		bookingError: false,

		bookedItems: [],
		// bookedItemsLoaded: false,
		// bookedItemsError: false,

		transactions: [],
		transactionsLoaded: false,
		transactionsError: false,
		tuitionChargeTotal: null,
		tuitionCreditTotal: null,
		fieldChargeTotal: null,
		fieldCreditTotal: null,
		fieldTransactions: [],
		fieldPayments: [],
		tuitionTransactions: [],
		tuitionPayments: [],
		insuranceTransactions: [],
		insuranceChargeTotal: null,
		insurancePayments: [],
		insuranceCreditTotal: null,

		remarks: null,
		remarksLoaded: false,
		remarksError: false,

		statuses: null,
		statusesLoaded: false,
		statusesError: false,

		agency: null,
		agencyLoaded: false,
		agencyError: false,

		GSCneeded: true,
		GSCused: false,

		isStudent: null,
		isStaff: null,
		isFaculty: null,
		isGapOrPost: null,
		isWaitList: null,
		hasDisplayedLoadingError: false,
		actionPlan: null,

		voyages: [],
	};

	getActionPlan = () => {
		axios.get(apiPath + '/admissions/getActionPlan', { withCredentials: true }).then((result) => {
			if (result.data === false) {
				this.setState({
					actionPlan: {
						Status: 'W',
					},
				});
			} else {
				this.setState({
					actionPlan: {
						Status: result.data.Status,
					},
				});
			}
		});
	};
	kickSession = (message = 'This session has ended due to activity detected elsewhere on the same account') => {
		this.props.history.push('/');
		stickyError(message);
	};
	handleErrorByPath = (error) => {
		const path = error.config.url;
		if (path === '/api/oldfolio') {
			this.setState({ folioError: error });
			return 'Login failed';
		} else if (path === '/api/folio') {
			this.setState({ folioError: error });
			return 'Failed to load folio';
		} else if (path === '/api/booking' || path === '/api/oldbooking') {
			if (path === '/api/booking') this.setState({ bookedItemsError: error });
			if (path === '/api/oldbooking') this.setState({ bookingError: error });
			return 'Failed to load booking';
		} else if (path.indexOf('agency') !== -1) return 'Failed to load agency';
		else if (path.indexOf('statuses') !== -1) return 'Failed to load statuses';
		else if (path.indexOf('remarks') !== -1) return 'Failed to load remarks';
		else if (path.indexOf('fieldclasses') !== -1) return 'An error occurred while loading field class information';
		else if (path === '/isstudent') return 'A booking-related error occurred';
		else return 'An error occurred';
	};
	handleAxiosLoadError = (error) => {
		const message = this.handleErrorByPath(error);
		if (!error.response || !error.response.status) {
			stickyError(message + ': Connection failed, try refreshing this page');
		} else if (error.response.status === 403) {
			this.kickSession();
		} else if (error.response.status === 401) {
			this.kickSession('Your session has timed out - please log in again to continue');
			this.props.history.push('/');
		} else {
			stickyError(message + ': ' + error.message, 0, true);
		}
		this.setState({ hasDisplayedLoadingError: true });
		return error;
	};
	handleAxiosSaveError = (error) => {
		if (!error.response || !error.response.status) {
			stickyError('Failed to save data: ' + error.message, 0, true);
		} else if (error.response.status === 401) {
			this.kickSession('Your session has timed out - please log in again to continue');
		} else {
			stickyError('Failed to save data: ' + error.message, 0, true);
			return error;
		}
	};
	loadFieldClasses = () => {
		axios
			.get(apiPath + '/fieldclasses', { withCredentials: true })
			.then((result) => {
				if (result.data && result.data.Item) localStorage.setItem('fieldClasses', JSON.stringify(result.data.Item));
				else stickyError('Failed to load field class data');
			})
			.catch((error) => {
				if (!localStorage.fieldClasses || localStorage.fieldClasses.length < 5) {
					return this.handleAxiosLoadError(error);
				}
			});
	};
	loadFolio = () => {
		this.setState({ folioLoaded: false });
		return axios.get(apiPath + '/folio', { withCredentials: true }).then((response) => {
			this.setState({
				folio: response.data,
				folioLoaded: true,
				folioError: false,
			});
		});
	};
	refreshBooking = () => {
		//do all the things to refresh the booking.
		this.checkIfWaitlist();

		return this.loadBooking();
	};

	loadBooking = () => {
		this.setState({ bookingLoaded: false });
		return axios.get(apiPath + '/booking', { withCredentials: true }).then((response) => {
			if (!response.data) {
				return stickyError('Error loading booking', 0, true);
			}
			const bookingResponse = {
				bookedItems: response.data.items,
				booking: {
					BookingId: response.data.BookingId,
					EventId: response.data.EventId,
					BookingCode: response.data.BookingCode,
					AgencyId: response.data.AgencyId,
				},
				bookingLoaded: true,
				bookingError: false,
				GSCused: response.data.items && response.data.items.find((item) => item.Comments.indexOf('GSCE - DO NOT CHARGE') !== -1),
			};
			this.setState(bookingResponse);
			calculateBalance(response, this.kickSession)
				.then((result) => {
					this.setState({
						transactions: result.transactions,
						transactionsLoaded: true,
						transactionsError: false,
						fieldChargeTotal: result.fieldChargeTotal,
						fieldCreditTotal: result.fieldCreditTotal,
						tuitionChargeTotal: result.tuitionChargeTotal,
						tuitionCreditTotal: result.tuitionCreditTotal,
						fieldTransactions: result.fieldTransactions,
						fieldPayments: result.fieldPayments,
						tuitionTransactions: result.tuitionTransactions,
						tuitionPayments: result.tuitionPayments,
						insuranceTransactions: result.insuranceTransactions,
						insuranceChargeTotal: result.insuranceChargeTotal,
						insurancePayments: result.insurancePayments,
						insuranceCreditTotal: result.insuranceCreditTotal,
					});
				})
				.catch((error) => {
					this.setState({ transactionsError: error });
				});

			//this.checkIfWaitlist();
			return bookingResponse;
		});
	};
	// oldLoadBooking = () => {
	// 	this.setState({ bookingLoaded: false });
	// 	return axios.get(apiPath+'/oldbooking', {withCredentials: true}).then(response => {
	// 		this.setState({
	// 			booking: response.data.Booking,
	// 			bookingLoaded: true,
	// 			bookingError: false
	// 		});
	// 		return response.data;
	// 	});
	// }
	loadAgency = () => {
		axios.get(apiPath + '/agency', { withCredentials: true }).then((result) => {
			this.setState({
				agency: result.data,
				isStaff:
					result.data.Name === 'Staff' || result.data.Name === 'Academic' || result.data.Name === 'Non-Academic' || result.data.Name === 'Child' || result.data.Name === 'Spouse/Partner',
				isFaculty: result.data.Name === 'Faculty',
				isGapOrPost: result.data.Name === 'GAP' || result.data.Name === 'Post-Graduate',
				isLLL: result.data.Name === 'Life Long Learner' || result.data.Name === 'Lifelong Learner',
				agencyLoaded: true,
				agencyError: false,
			});
		});
	};
	loadRemarks = () => {
		return axios.get(apiPath + '/remarks', { withCredentials: true }).then((response) => {
			this.setState({
				remarks: response.data,
				remarksLoaded: true,
				remarksError: false,
			});
		});
	};
	loadStatuses = () => {
		return axios.get(apiPath + '/statuses', { withCredentials: true }).then((response) => {
			this.setState({
				statuses: response.data,
				statusesLoaded: true,
				statusesError: false,
			});
		});
	};
	loadPortalConfig = () => {
		return axios.get(apiPath + '/portalconfig', { withCredentials: true }).then((response) => {
			this.setState({ configRules: response.data });
		});
	};
	loadEverything = () => {
		this.loadFolio()
			.then((result) => {
				// this.oldLoadBooking()
				this.loadBooking()
					.then((bookingResponse) => {
						this.checkForShuttle(bookingResponse.bookedItems);
					})
					.then(this.loadAgency)
					.then(this.checkIfStudent)
					.then(this.checkIfWaitlist)
					.then(this.loadRemarks)
					.then(this.loadStatuses)
					.then(this.getActionPlan);
			})
			.catch((error) => {
				localStorage.setItem('redirectAfterLogin', window.location.hash);
				return this.handleAxiosLoadError(error);
			});
		this.loadPortalConfig();
		this.loadFieldClasses();
	};
	checkIfStudent = () => {
		axios.get(apiPath + '/isstudent', { withCredentials: true }).then((response) => {
			this.setState({
				isStudent: response.data,
				GSCneeded: response.data,
			});
		});
	};
	checkIfWaitlist = () => {
		axios.get(apiPath + '/iswaitlist', { withCredentials: true }).then((response) => {
			this.setState({
				isWaitList: response.data,
			});
		});
	};
	checkForShuttle = (booking) => {
		this.setState({ bookingHasShuttle: !!booking.find((item) => item.StoreId === '41') });
	};
	checkIfLoaded = () => {
		if (this.state.folioLoaded && this.state.bookingLoaded && this.state.transactionsLoaded) {
			// && this.state.statusesLoaded) {
			this.props.isDoneLoading();
		} else window.setTimeout(this.checkIfLoaded, 500);
	};
	updateFolio = (form, subsection) => {
		return new Promise((resolve, reject) => {
			form.validateFields((errors, values) => {
				if (values.BirthDate) {
					values.BirthDate = moment(values.BirthDate).format('YYYY-MM-DDT00:00:00');
				}
				if (values.Street) {
					values.Street = values.Street.split('\n').join('&#x0d;&#x0a;');
				}
				if (errors) {
					const firstErrorMessage = errors[Object.keys(errors)[0]].errors[0].message;
					stickyError('Validation error: ' + firstErrorMessage, 4.5);
					reject(errors);
				} else {
					let update = {};
					switch (subsection) {
						case 'DocumentList':
							const Nationality = values.Nationality;
							delete values.Nationality;
							delete values.copy;
							delete values.photo;
							values.IssueDate = moment(values.IssueDate).format('YYYY-MM-DDT00:00:00');
							values.ExpiryDate = moment(values.ExpiryDate).format('YYYY-MM-DDT00:00:00');
							update = { DocumentList: { Document: values } };
							if (Nationality) update.Nationality = Nationality;
							break;
						case 'Emergency':
							update = { Emergency: values };
							break;
						case 'Visas':
							update = {
								DocumentList: Object.keys(values)
									.filter((key) => key.substring(0, 10) !== 'DocumentId')
									.filter((key) => {
										return values[key];
									})
									.map((key) => {
										let doc = {
											Type: 'V',
											IssueCountry: key,
											No: 'none',
											ExpiryDate: values[key],
										};
										if (values['DocumentId_' + key]) doc.DocumentId = values['DocumentId_' + key];
										else doc.ExternalId = key + moment().format('x');
										return doc;
									}),
							};
							break;
						default:
							update = values;
							break;
					}
					axios
						.put(apiPath + '/folio', update, { withCredentials: true })
						.then((response) => {
							if (!response || !response.data || !response.data.Result || response.data.Result.Status !== 'A') {
								let e = { message: 'Unknown error' };
								this.handleAxiosSaveError(e);
								reject(e);
								return;
							}
							notification.success({ message: 'Saved!' });
							const newFolio = Object.assign(this.state.folio, update);
							this.setState({ folio: newFolio });
							resolve(newFolio);
						})
						.catch((error) => {
							this.handleAxiosSaveError(error);
							reject(error);
						});
				}
			});
		});
	};
	updateStatuses = (form, trueValue, falseValue) => {
		return new Promise((resolve, reject) => {
			form.validateFields((errors, values) => {
				if (errors) {
					const firstErrorMessage = errors[Object.keys(errors)[0]].errors[0].message;
					stickyError('Validation error: ' + firstErrorMessage, 4.5);
					reject(errors);
				} else {
					if (trueValue) {
						for (let v in values) {
							if (v.indexOf('SRI_') === -1) delete values[v];
							else values[v] = values[v] ? trueValue : falseValue;
						}
					}
					for (let v in values) {
						if (['SRI_YELLOW_FEVER_VAC'].indexOf(v) !== -1) {
							// dates
							values[v] = values[v].format('YYYY-MM-DD');
						}
					}
					axios
						.put(apiPath + '/statuses', values, { withCredentials: true })
						.then((response) => {
							notification.success({ message: 'Saved!' });
							const newStatuses = Object.assign(this.state.statuses, values);
							this.setState({ statuses: newStatuses });
							resolve(newStatuses);
						})
						.catch((error) => {
							this.handleAxiosSaveError(error);
							reject(error);
						});
				}
			});
		});
	};
	getSectionsFromProps = (props) => {
		this.setState({
			section: props.location.pathname.split('/')[2],
			subsection: props.location.pathname.split('/')[3],
		});
	};

	getVoyages = async () => {
		try {
			const response = await fetch(`${apiPath}/voyages?pastEvents=1`);

			if (!response.ok) {
				throw new Error(response.statusText);
			}

			const voyages = await response.json();

			this.setState({ voyages });
		} catch (error) {
			console.error(error);
		}
	};

	componentWillReceiveProps(nextProps) {
		this.getSectionsFromProps(nextProps);
		window.clearInterval(this._tick);
		this._tick = null;
		this._tick = window.setInterval(() => this.setState({ tick: !this.state.tick }), 1000 * 60);
	}
	componentWillMount() {
		this.props.isLoading();
		this.getSectionsFromProps(this.props);

		// update sections every 1 minutes
		if (!this._tick) this._tick = window.setInterval(() => this.setState({ tick: !this.state.tick }), 1000 * 60);
	}
	componentDidMount() {
		notification.destroy();
		this.loadEverything();
		this.checkIfLoaded();
		this.getVoyages();
	}
	componentWillUnmount() {
		window.clearInterval(this._tick);
	}
	render() {
		let routeProps = {
			variant: 'normal',
			configRules: this.state.configRules,
			sectionIsEnabled: isEnabled,
			redirectIfHidden: redirectIfHidden,

			folio: this.state.folio,
			folioLoaded: this.state.folioLoaded,
			folioError: this.state.folioError,
			updateFolio: this.updateFolio,
			refreshFolio: this.loadFolio,

			booking: this.state.booking,
			bookingLoaded: this.state.bookingLoaded,
			bookingError: this.state.bookingError,
			bookedItems: this.state.bookedItems,
			bookingHasShuttle: this.state.bookingHasShuttle,
			refreshBooking: this.refreshBooking,

			transactions: this.state.transactions,
			transactionsLoaded: this.state.transactionsLoaded,
			transactionsError: this.state.transactionsError,
			fieldChargeTotal: this.state.fieldChargeTotal,
			fieldCreditTotal: this.state.fieldCreditTotal,
			tuitionChargeTotal: this.state.tuitionChargeTotal,
			tuitionCreditTotal: this.state.tuitionCreditTotal,
			fieldTransactions: this.state.fieldTransactions,
			fieldPayments: this.state.fieldPayments,
			tuitionTransactions: this.state.tuitionTransactions,
			tuitionPayments: this.state.tuitionPayments,
			insuranceTransactions: this.state.insuranceTransactions,
			insuranceChargeTotal: this.state.insuranceChargeTotal,
			insurancePayments: this.state.insurancePayments,
			insuranceCreditTotal: this.state.insuranceCreditTotal,

			remarks: this.state.remarks,
			remarksLoaded: this.state.remarksLoaded,
			remarksError: this.state.remarksError,
			refreshRemarks: this.loadRemarks,

			statuses: this.state.statuses,
			statusesLoaded: this.state.statusesLoaded,
			statusesError: this.state.statusesError,
			updateStatuses: this.updateStatuses,
			refreshStatuses: this.loadStatuses,

			agency: this.state.agency,
			agencyLoaded: this.state.agencyLoaded,
			agencyError: this.state.agencyError,

			GSCused: this.state.GSCused,
			GSCneeded: this.state.GSCneeded,
			isStudent: this.state.isStudent,
			isStaff: this.state.isStaff,
			isFaculty: this.state.isFaculty,
			isGapOrPost: this.state.isGapOrPost,
			isLLL: this.state.isLLL,
			isWaitList: this.state.isWaitList,
			kickSession: this.kickSession,
			academicActionStatus: this.state.actionPlan && this.state.actionPlan.Status,

			handleAxiosLoadError: this.handleAxiosLoadError,
			handleAxiosSaveError: this.handleAxiosSaveError,
			anyError: this.state.folioError || this.state.bookingError || this.state.bookedItemsError || this.state.transactionsError || this.state.statusesError || this.state.agencyError,
		};

		const menuItemsWithProps = menuItems(routeProps);
		const props = routeProps;
		const visibleMenuItems = menuItemsWithProps.filter((item) => item.visible || (item.children && item.children.find((child) => child.visible)));
		const portalEnabledForVoyage = visibleMenuItems.length > 0;
		const activeSection = menuItemsWithProps.find((item) => {
			return item.key.toLowerCase() === this.state.section;
		});
		const activeSectionTitle = !activeSection ? '' : typeof activeSection.titleText === 'function' ? activeSection.titleText() : activeSection.titleText;

		return (
			<App props={{ ...props }}>
				<Layout>
					{this.state.folioError && <Redirect to='/' />}

					<Sider breakpoint='sm' width='250' collapsedWidth='0'>
						<Sidebar
							voyages={this.state.voyages}
							menuItems={menuItemsWithProps}
							GSCused={this.state.GSCused}
							GSCneeded={this.state.GSCneeded}
							booking={this.state.booking}
							refreshBooking={this.refreshBooking}
							refreshStatuses={this.loadStatuses}
						/>
					</Sider>

					<Content>
						{this.state.bookingLoaded && !portalEnabledForVoyage && <h3 style={{ margin: '8pt 32pt' }}>The portal is not currently available for this voyage</h3>}

						{false &&
							routeProps.anyError && ( // remove false for testing
								<div>
									<div>{this.state.folioError !== false ? 'folioError' : 'no folioError'}</div>
									<div>{this.state.bookingError !== false ? 'bookingError' : 'no bookingError'}</div>
									<div>{this.state.bookedItemsError !== false ? 'bookedItemsError' : 'no bookedItemsError'}</div>
									<div>{this.state.transactionsError !== false ? 'transactionsError' : 'no transactionsError'}</div>
									<div>{this.state.statusesError !== false ? 'statusesError' : 'no statusesError'}</div>
									<div>{this.state.agencyError !== false ? 'agencyError' : 'no agencyError'}</div>
								</div>
							)}

						{this.state.bookingLoaded && portalEnabledForVoyage && (
							<div style={{ padding: '8pt' }}>
								<Breadcrumb>
									{activeSection && (
										<Breadcrumb.Item>
											<Link to='/portal'>Portal</Link>
										</Breadcrumb.Item>
									)}
									{activeSection && (
										<Breadcrumb.Item>
											<Link to={'/portal/' + this.state.section}>{activeSectionTitle}</Link>
										</Breadcrumb.Item>
									)}
									<Breadcrumb.Item>{this.state.subsection}</Breadcrumb.Item>
								</Breadcrumb>
							</div>
						)}

						{this.state.bookingLoaded && portalEnabledForVoyage && (this.state.subsection || (activeSection && activeSection.titleText)) && (
							<h1 style={{ margin: '8pt 32pt' }}>{this.state.subsection || activeSection.titleText}</h1>
						)}

						{portalEnabledForVoyage && (
							<div style={{ padding: '16pt 32pt' }}>
								<Switch>
									<Route path='/portal/Payment Error' component={PaymentError} />
									<Route path='/portal/Payment Failed' component={PaymentFailed} />
									<Route path='/portal/safety' render={() => (visibleMenuItems.find((item) => item.key === 'Safety') ? <Safety {...routeProps} /> : <Redirect to='/portal' />)} />
									<Route
										path='/portal/personal'
										render={() => (visibleMenuItems.find((item) => item.key === 'Personal') ? <Personal {...routeProps} /> : <Redirect to='/portal' />)}
									/>
									<Route
										path='/portal/admissions'
										render={() => (visibleMenuItems.find((item) => item.key === 'Admissions') ? <Admissions {...routeProps} /> : <Redirect to='/portal' />)}
									/>
									<Route
										path='/portal/field'
										render={() => (visibleMenuItems.find((item) => item.key === 'Field') ? <FieldPrograms {...routeProps} /> : <Redirect to='/portal' />)}
									/>
									<Route
										path='/portal/embarkation'
										render={() => (visibleMenuItems.find((item) => item.key === 'Embarkation') ? <Embarkation {...routeProps} /> : <Redirect to='/portal' />)}
									/>
									<Route
										path='/portal/financial'
										render={() => (visibleMenuItems.find((item) => item.key === 'Financial') ? <Financial {...routeProps} /> : <Redirect to='/portal' />)}
									/>
									<Route
										path='/portal/academic'
										render={() => (visibleMenuItems.find((item) => item.key === 'Academic') ? <Academic {...routeProps} /> : <Redirect to='/portal' />)}
									/>
									<Route path='/portal/health' render={() => (visibleMenuItems.find((item) => item.key === 'Health') ? <Health {...routeProps} /> : <Redirect to='/portal' />)} />
									<Route path='/portal/travel' render={() => (visibleMenuItems.find((item) => item.key === 'Travel') ? <Travel {...routeProps} /> : <Redirect to='/portal' />)} />
									<Route
										path='/portal/agreements'
										render={() => (visibleMenuItems.find((item) => item.key === 'Agreements') ? <Agreements {...routeProps} /> : <Redirect to='/portal' />)}
									/>
									<Route path='/portal/cabin' render={() => (visibleMenuItems.find((item) => item.key === 'Cabin') ? <Cabin {...routeProps} /> : <Redirect to='/portal' />)} />
									<Route
										path='*'
										render={() => {
											return (
												<div>
													<h3>Welcome!</h3>
													{!this.state.folioError && localStorage.redirectAfterLogin ? (
														<RedirectAndClear to={localStorage.redirectAfterLogin.substring(1)} />
													) : (
														<Redirect to='/portal/financial/' />
													)}
												</div>
											);
										}}
									/>
								</Switch>
							</div>
						)}
					</Content>
				</Layout>
			</App>
		);
	}
}

export default withRouter(withSpin(Portal));



// WEBPACK FOOTER //
// ./src/containers/Portal/index.jsx